import { Client } from '@/common/services/Client';

interface AssignBillingsRequest {
  billingUuids: string[];
}

export async function assignBillings(billingUuids: string[]): Promise<void> {
  const response = await Client.patch<void, AssignBillingsRequest>({
    body: {
      billingUuids: billingUuids,
    },
    endpoint: `/billing/assign`,
  });
  return response.data;
}
